var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoggedIn)?_c('div',{staticClass:"page page--account"},[_c('Sharing'),_c('MakeOffers'),_c('ShareQuery'),_c('Sales')],1):_c('div',{staticClass:"page page--account"},[_c('Login')],1)}
var staticRenderFns = []

export { render, staticRenderFns }